import { isMobile } from '@farmasiet/frontendcore-reactcomponents';
import classnames from 'classnames';
import React from 'react';

import { ProductCardVariant } from '../ProductCardVariant.csharp';

interface IProductCardPlaceholderProps {
    variant: ProductCardVariant;
}

export const ProductCardPlaceholder = ({ variant }: IProductCardPlaceholderProps) => {
    return (
        <>
            <div className={classnames('ProductCardPlaceholder', `ProductCardPlaceholder--${ProductCardVariant[variant]}`)}>
                <div className="ProductCardPlaceholder__Image" />
                <div className="ProductCardPlaceholder__TextWrapper">
                    <div className="ProductCardPlaceholder__TextLine ProductCardPlaceholder__TextLine--Short" />
                    <div className="ProductCardPlaceholder__TextLine" />
                    <div className="ProductCardPlaceholder__TextLine" />
                    <div className="ProductCardPlaceholder__TextLine ProductCardPlaceholder__TextLine--Short" />
                </div>
                <div className="ProductCardPlaceholder__Button" />
            </div>
            {isMobile() && variant === ProductCardVariant.HorizontalCompact && (
                <div className="ProductCardPlaceholder__HorizontalCompactFooter">
                    <div className="ProductCardPlaceholder__TextLine ProductCardPlaceholder__TextLine--Short" />
                    <div className="ProductCardPlaceholder__Button" />
                </div>
            )}
        </>
    );
};
